
















































import {Component, Mixins} from 'vue-property-decorator';
import { CaseInfoSenderListInfo, ColumnRetrieveResponse,
  CommonModelUtils, MultipleSendersSelectDialogRequest, TableHeader} from '@/model/CommonModel';
import CommonPaginatedTable from '@/components/table/CommonPaginatedTable.vue';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import CommonApi from '@/api/CommonApi';
import CaseInfoApi from '@/api/CaseInfoApi';
import DefaultPaginateMixin from '@/views/DefaultPaginateMixin';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import TextInput from '@/components/input/TextInput.vue';
import SelectDialogMixin from '@/components/dialog/SelectDialogMixin';
import IconButton from '@/components/button/IconButton.vue';

@Component({
    components: {IconButton, TextInput, CommonPromptDialog, CommonPaginatedTable, CommonButton},
    mixins: [DefaultPaginateMixin, DialogEventsMixin, SelectDialogMixin]
})
export default class MultipleSendersSelectDialog extends Mixins(DefaultPaginateMixin, DialogEventsMixin, SelectDialogMixin) {
    private readonly menuId: string = 'MU-CI-SD';
    private readonly columnIds: string[] = [
        'SENDER_KEY',
        'SND_ORGAN',
        'SND_GIV_NAME'
    ];

    private selectedSenders: CaseInfoSenderListInfo[] = [];
    private selectedSenderKeyMap: any = {};
    private selectedProductKeys: string = '';
    private selectedStudyKeys: string = '';
    private values: CaseInfoSenderListInfo[] = [];
    private onSelect: ($event: any, senders: CaseInfoSenderListInfo[]) => void;

    get getValues() {
        return this.values;
    }

    get isLoading() {
        return this.loading;
    }

    get getRowClassSupplier() {
        return (row: any) => {
            return {'selected': this.selectedSenderKeyMap[row.SENDER_KEY]};
        };
    }

    public getLabel(sender: CaseInfoSenderListInfo) {
        return sender.SND_ORGAN
            ? `${sender.SND_ORGAN.length > 40 ? `${sender.SND_ORGAN.substr(0, 40)}...` : sender.SND_ORGAN}`
            : '';
    }

    public mounted() {
        this.$modal
            .getEventBus()
            .$on('multipleSendersSelectDialog', (params: MultipleSendersSelectDialogRequest) => {
                this.width = params.width ? params.width : this.DEFAULT_WIDTH;
                this.selectedSenders = [...params.selectedSenders];
                this.selectedSenderKeyMap = this.selectedSenders.reduce((map: any, sender: CaseInfoSenderListInfo) => {
                    map[sender.SENDER_KEY] = sender.SENDER_KEY;
                    return map;
                }, {});
                this.selectedProductKeys = params.selectedProductKeys;
                this.selectedStudyKeys = params.selectedStudyKeys;
                this.show(params);
            });

        this.$modal.getEventBus().$on('hideMultipleSendersSelectDialog', () => this.onCancel());
    }

    public show(request: MultipleSendersSelectDialogRequest) {
        this.visible = true;
        this.onSelect = request.onSelect;
        this.retrieve(1, 10)
            .then(() => this.setSelectedOptions());
    }

    public onCloseTag($event: MouseEvent, target: CaseInfoSenderListInfo) {
        const targetIndex = this.selectedSenders.findIndex((sender: CaseInfoSenderListInfo) => sender.SENDER_KEY === target.SENDER_KEY);
        this.unSelect(targetIndex);
    }

    public onRowClick(data: any) {
        const {row, $event} = data;
        const targetIndex = this.selectedSenders.findIndex((sender: CaseInfoSenderListInfo) => sender.SENDER_KEY === row.SENDER_KEY);
        if (targetIndex >= 0) {
            this.unSelect(targetIndex);
        } else {
            this.selectedSenders.push(row);
            this.selectedSenderKeyMap = {
                ...this.selectedSenderKeyMap,
                [row.SENDER_KEY]: row.SENDER_KEY
            };
        }
    }

    private unSelect(targetIndex: number) {
        if (targetIndex >= 0) {
            const unSelected: CaseInfoSenderListInfo = this.selectedSenders.splice(targetIndex, 1)[0];
            this.selectedSenderKeyMap[unSelected.SENDER_KEY] = false;
        }
    }

    public retrieve(pageNo: number, rowCount: number) {
        this.loading = true;
        return Promise.all([
                          this.getColumnRetrievePromise(),
                          CaseInfoApi.retrieveCaseInfoSenderOptions(this.$route.params.sponsorKey,
                              {pageNo, rowCount, selectedProductKeys: this.selectedProductKeys,
                                selectedStudyKeys: this.selectedStudyKeys, keyword: this.keyword})
                      ])
                      .then((values: any[]) => {
                          if (!values[0].success) {
                              return Promise.reject(values[0].errMsg);
                          }
                          const columns = CommonModelUtils.getOrDefault(values[0].data, {columnList: []}).columnList
                                                          .filter(((column: TableHeader) => this.columnIds.includes(column.columnId)));
                          this.columns = this.initializeColumns(columns);

                          if (!values[1].success) {
                              return Promise.reject(values[1].errMsg);
                          }
                          const paginate = CommonModelUtils.getOrDefaultPaginate(values[1].data);
                          this.values = paginate.listInfo;
                          this.pageInfo = paginate.pageInfo;
                      })
                      .catch((errMsg) => this.afterRequestFail(errMsg))
                      .finally(() => this.loading = false);
    }

    private getColumnRetrievePromise(): Promise<ColumnRetrieveResponse> {
        if (this.columns && this.columns.length > 0) {
            return Promise.resolve({
                data: {
                    columnList: this.columns
                },
                success: true
            });
        }
        return CommonApi.retrieveColumns(this.menuId);
    }

    public onConfirm($event: any) {
        this.onSelect($event, this.selectedSenders);
        this.visible = false;
    }

    public onCancel() {
        this.visible = false;
    }

    public afterClosed() {
        this.values = [];
        this.selectedSenders = [];
        this.selectedSenderKeyMap = {};
        this.keyword = '';
        this.loading = false;
    }

    public setSelectedOptions() {
      CaseInfoApi.retrieveCaseInfoSenderOptions(this.$route.params.sponsorKey,
          {
            pageNo: 0,
            rowCount: this.pageInfo.totalCount,
            selectedProductKeys: this.selectedProductKeys,
            selectedStudyKeys: this.selectedStudyKeys
          })
          .then((res) => {
            if (!res.success) {
              return Promise.reject(res.errMsg);
            }

            const selectedSenderKeys = res.data.listInfo.map(sender => sender.SENDER_KEY);

            this.selectedSenders = this.selectedSenders.filter(sender => selectedSenderKeys.includes(sender.SENDER_KEY));
            this.selectedSenderKeyMap = this.selectedSenders.reduce((map: any, sender: CaseInfoSenderListInfo) => {
              map[sender.SENDER_KEY] = sender.SENDER_KEY;
              return map;
            }, {});


          }).catch((errMsg) => this.afterRequestFail(errMsg))
          .finally(() => this.loading = false);
    }

    public destroyed() {
        this.$modal.getEventBus().$off('multipleSendersSelectDialog');
        this.$modal.getEventBus().$off('hideMultipleSendersSelectDialog');
    }
}
